import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsBO: CultureInfo = {
  name: 'es-BO',
  displayName: 'Spanish (Bolivia)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-BO',
  parent: CultureInfoEs
};
